(function(){
  'use strict';
  function start(){
    const button=document.querySelector('[data-lpc-whatsapp-float]');if(!button)return;
    let scheduled=false;const observed=new WeakSet();
    function update(){
      scheduled=false;const scopes=[document];document.querySelectorAll('[data-smooche-integrated]').forEach(h=>{if(h.shadowRoot)scopes.push(h.shadowRoot);});
      scopes.forEach(scope=>{if(observed.has(scope))return;observed.add(scope);observer.observe(scope,{subtree:true,childList:true,attributes:true,attributeFilter:['open','hidden','class','style']});});
      const modal=scopes.some(scope=>[...scope.querySelectorAll('dialog[open], [aria-modal="true"]')].some(el=>el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden'));
      const firstScreen=matchMedia('(max-width:749px)').matches&&scrollY<innerHeight*0.6;
      button.hidden=modal||firstScreen;
      let bottom=16;
      if(matchMedia('(max-width:749px)').matches&&!modal){
        const bounds=button.getBoundingClientRect();
        for(const scope of scopes)scope.querySelectorAll('[data-sticky],.sm-sticky-cart,.apple-sticky-atc,button[name="checkout"],[href="/checkout"],.cart__checkout-button,[data-cart-checkout]').forEach(el=>{
          const r=el.getBoundingClientRect(),style=getComputedStyle(el);
          if(el.hidden||style.display==='none'||style.visibility==='hidden'||r.width===0||r.bottom<=0||r.top>=innerHeight)return;
          if(r.left<bounds.right&&r.right>bounds.left){
            const y=innerHeight-bottom-button.offsetHeight;
            const sticky=el.matches('[data-sticky],.sm-sticky-cart,.apple-sticky-atc')||style.position==='fixed';
            if(sticky||(y<r.bottom&&y+button.offsetHeight>r.top))bottom=Math.max(bottom,innerHeight-r.top+12);
          }
        });
      }
      const value='calc('+bottom+'px + env(safe-area-inset-bottom, 0px))';if(button.style.bottom!==value)button.style.bottom=value;
    }
    function queue(){if(!scheduled){scheduled=true;requestAnimationFrame(update);}}
    const observer=new MutationObserver(changes=>{if(changes.some(c=>c.target!==button))queue();});
    addEventListener('scroll',queue,{passive:true});addEventListener('resize',queue);document.addEventListener('lpc:purchase-mounted',queue);document.addEventListener('toggle',queue,true);update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
